import { ChecklistItem, ChecklistItemType } from './checklist-item';
import { Customer } from './customer';
import { Deserializable } from './deserializable';
import { Segment } from './segment';

export class Checklist implements Deserializable {
  id: number;
  name: string;
  customer: Customer;
  speechCategorySkipIntegration: string;
  segment: Segment;
  segmentId: number;
  checkListType?: string | 'MANUAL' | 'AUTOMATIC' | 'MULTIPLE';

  speechCategoryEffectiveIntegration: string;
  speechCategoryNonEffectiveIntegration: string;

  itensChecklist: ChecklistItem[] = [];

  metadata: any;

  active: boolean = true;

  itemType: ChecklistItemType = ChecklistItemType.FIXED;

  parent?: Checklist;
  parentChecklistId?: number;
  weight?: number; // impacto

  operationsIds?: number[] = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
